<template>
  <div>
    <div
      v-if="pageType !== 'transaction' && items?.length > 0"
      class="d-flex align-items-center gap-2"
    >
      <McButton
        v-if="hasBackButton"
        variant="minimal"
        size="sm"
        icon="icon-outline_arrow-left"
        :text="backButtonText"
        @click="handleBackButton"
      />
      <b-breadcrumb v-if="handleItems.length > 0" class="mc-drop-container m-0 p-0">
        <b-breadcrumb-item
          v-for="item in handleItems"
          :href="item.href"
          :to="item.to"
          @click="onLinkClicked"
          >{{ item.text }}</b-breadcrumb-item
        >
        <b-nav vertical v-if="showDropdown" class="mc-custom-breadcrumb">
          <b-nav-item v-for="item in dropdownItems" :href="item.href" :to="item.to">
            {{ item.text }}</b-nav-item
          >
        </b-nav>
      </b-breadcrumb>
    </div>
    <McButton
      v-else
      variant="minimal"
      size="sm"
      icon="icon-outline_arrow-left"
      :text="backButtonText"
      @click="handleBackButton"
    />
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pageType: {
      type: String,
      default: () => '',
    },
    routeBack: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDropdown: false,
      dropItems: [],
    }
  },
  computed: {
    handleItems() {
      const items = this.items.slice()
      if (this.items?.length > 0 && this.items?.length <= 3) {
        return items
      }
      const dots = {
        text: '...',
        isKey: true,
      }
      items.splice(3, items.length - 4, dots)
      return items
    },
    dropdownItems() {
      const items = this.items.slice()
      return items.slice(3, items.length)
    },
    backButtonText() {
      if (this.pageType !== 'transaction') return ''
      return this.buttonText ? this.buttonText : this.$t('global.back')
    },
  },
  methods: {
    onLinkClicked(e) {
      if (e.target.innerText !== '...') return
      this.showDropdown = !this.showDropdown
    },
    handleBackButton() {
      if (this.routeBack) {
        return this.$router
          .push({
            path: this.routeBack,
          })
          .catch(() => {})
      }

      return this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
.nav li:hover a {
  background: rgba(61, 105, 167, 1);
  color: #fff;
}

.nav li a {
  color: inherit;
}
</style>
